// Constants not prefixed with `meeting`, besides meetingTime, used as sorting keys in API
export const MEETING_ID = "id";
export const MEETING_TYPE = "meetingType";
export const MEETING_LAST_ACTIVITY = "lastActivity";
export const MEETING_INSTANCE_VALUE = "cost";
export const MEETING_TAGS = "meetingTags";
export const MEETING_START_TIME = "meetingTime";
